export default "__VITE_ASSET__D2fw4HBX__"